import PropTypes from 'prop-types';

const groupPropType = PropTypes.shape({
  _id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
});

export default groupPropType;
